export default class BubbleLoader {
  constructor(container) {
    this.container = container;
    this.VISIBLE = false;
  }

  show() {
    this.VISIBLE = true;
    this.container.classList.remove("hide");
    this.container.classList.add("bounceInLeft");
  }

  hide() {
    this.VISIBLE = false;
    this.container.classList.remove("bounceInLeft");
    this.container.classList.add("bounceOutRight");
    window.setTimeout(() => {
      this.container.classList.add("hide");
      this.container.classList.remove("bounceOutRight");
    }, 1000);
  }
}
